import React, { useState } from 'react'

import FormEduc from './localFormEducation/FormEduc'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom'

const FormPopUpEducation = ({ setActiveForm, season, setActivePopUp, checkDomenNameState, retake, setRetake, captchaSiteKey }) => {
  const [successSend, setSuccessSend] = useState(false)

  const uploadForm = () => {
    setActiveForm(false)
    setRetake(false)
  }
  const prevRoute = location?.pathname

  return (
    <div style={{ position: 'relative' }}>
      <p onClick={() => setRetake(true)} className={styles.wrapper_total_right_p1}>
        <span>&larr;</span>Вернуться назад
      </p>

      {retake && (
        <div className={styles.retake_wrapper}>
          <p className={styles.retake_wrapper_p1}>Закрыть форму?</p>
          <p className={styles.retake_wrapper_p2}>
            Вы начали заполнять форму отклика на вакансию. Если ее закрыть, то заполненные поля не сохранятся.
          </p>
          <div className={styles.retake_wrapper_btn}>
            <button className={styles.retake_wrapper_btn_1} onClick={() => setRetake(false)}>
              Остаться
            </button>
            <Link
              className={styles.retake_wrapper_btn_2}
              onClick={uploadForm}
              to={!prevRoute ? '/' : prevRoute}
              state={prevRoute}
            >
              Закрыть форму
            </Link>
          </div>
        </div>
      )}

      <p className={styles.wrapper_total_right_p2}>→ Подай заявку на программу</p>
      <div className={styles.info_program_block}>
        <p className={styles.info_program_block_p1}>{season[1]}</p>
        <p className={styles.info_program_block_p2}>{season[0]}</p>
        <p className={styles.info_program_block_p3} onClick={() => setActiveForm(null)}>
          Выбрать другую программу <span>&rarr;</span>
        </p>
      </div>
      {!successSend && (
        <FormEduc
          season={season[1]}
          checkDomenNameState={checkDomenNameState}
          setSuccessSend={setSuccessSend}
          setActivePopUp={setActivePopUp}
          captchaSiteKey={captchaSiteKey}
        />
      )}

      {successSend && (
        <div className={styles.success_block}>
          <p className={styles.success_block_p3}>{season[1]}</p>
          <p className={styles.success_block_p4}>{season[0]}</p>
          <p className={styles.success_block_p1}>Заявка успешно отправлена!</p>
          <p className={styles.success_block_p2}>Мы скоро с тобой свяжемся.</p>
        </div>
      )}
    </div>
  )
}

export default FormPopUpEducation
